import { SidebarType } from '@src/features/order/pages/upsert-mission-page/entities';
import { IUpsertMissionInitialState, TerrainMode } from "./types";

export const initialState: IUpsertMissionInitialState = {
  waypoints: [],
  hoveredDrone: null,
  selectedDrone: null,
  editableRoute: false,
  terrainMode: TerrainMode.RELATIVE,
  sidebarType: SidebarType.SELECT_DRONE,
};